import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Avatar, Paper, Subheader} from "material-ui";
import gravatar from 'gravatar';
import styles from './EditAdminPage.css';
import style from '../../../styles/styles';
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import AdminForm from "../../../components/admin/AdminForm/AdminForm";
import {fetchAdmin, resetAdmin, putAdmin} from '../../../store/admins/actions'
import {ADMIN_PAGE} from "../../../constants/routes";

export class EditAdminPage extends React.Component {

    static propTypes = {
        admin: PropTypes.object
    };

    static defaultProps = {
        loading: true,
        admin: null
    };

    constructor(props) {
        super(props);
        this.fetchAdmin();
    }

    componentWillMount() {
        this.update(this.props);
    }

    componentWillUnmount() {
        resetAdmin();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            this.props.history.push(ADMIN_PAGE.replace(':adminId', this.props.admin.id));
        }

        if (nextProps !== this.props) {
            this.update(nextProps);
        }
    }

    update(props) {
        if (!props.admin && !props.appError) {
            this.fetchAdmin();
        }
    }

    fetchAdmin() {
        if (this.props.match) {
            const id = this.props.match.params.adminId;
            if (id) {
                this.props.fetchAdmin(id)
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
       await this.props.putAdmin(formProps);
    };

    render() {
        if (this.props.adminError) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.admin) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Admin / Edit</h3>
                    <Avatar src={gravatar.url(this.props.admin.email)}
                            size={75}
                            style={styles.avatar}/>
                    <Paper style={styles.editBox}>
                        <Subheader
                            style={style.subHeader}>{this.props.admin.firstname} {this.props.admin.lastname}</Subheader>
                        <div style={style.paper}>
                            <AdminForm onSubmit={this.handleFormSubmit} initialValues={this.props.initialValues}/>
                        </div>
                        <div style={style.clear}/>
                    </Paper>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.admins.pending,
        adminError: state.admins.error
    };

    if (state.admins.currentAdmin) {
        props.admin = state.admins.currentAdmin;
        props.sending = state.admins.sending;
        props.initialValues = state.admins.currentAdmin;
    }

    return props;
}

export default connect(mapStateToProps, {fetchAdmin, putAdmin})(EditAdminPage);



// WEBPACK FOOTER //
// src/containers/admin/EditAdminPage/EditAdminPage.js